import * as React from 'react';

import { openClientInfoFromDeeplinkThunk } from '../../../actions/userCard/openClientInfoFromDeeplink';
import { EUserCardTab } from '../../../components/UserCard/UserCardSwitcher/types';
import { USER_CARD_TAB_QUERY_PARAM } from '../../../constants/deeplinkQueryParams';
import { currentOpenChatIDSelector } from '../../../selectors/currentOpenChatIDSelector';
import { useAppDispatch } from '../../../types/redux/state';
import { buildUrlWithQuery } from '../../../utils/buildUrlWithQuery';
import { useSelector } from 'react-redux';

/**
 * Обрабатывает диплинк `/dialogs/?chatId=<id>&userCardTab=clientInfo`: после открытия чата
 * открывает карточку собеседника на вкладке «О клиенте» (если информация доступна)
 * и вычищает параметр `userCardTab` из URL, чтобы он не сработал повторно.
 */
export const useOpenClientInfoFromDeeplink = (): void => {
  const dispatch = useAppDispatch();
  const currentOpenChatId = useSelector(currentOpenChatIDSelector);

  React.useEffect(() => {
    if (!currentOpenChatId) {
      return;
    }

    const queryParams = new URLSearchParams(window.location.search);

    if (queryParams.get(USER_CARD_TAB_QUERY_PARAM) !== EUserCardTab.About) {
      return;
    }

    queryParams.delete(USER_CARD_TAB_QUERY_PARAM);
    const newUrl = buildUrlWithQuery(window.location.pathname, queryParams.toString());
    window.history.replaceState(null, '', newUrl);

    dispatch(openClientInfoFromDeeplinkThunk());
  }, []);
};
